<highcharts-chart
  #chart
  class="m-line-chart"
  [Highcharts]="Highcharts"
  [options]="chartOptions"></highcharts-chart>
